import { defineComponent, ref } from 'vue';
export default defineComponent({
  setup() {
    let pageActive = ref(false);
    return {
      pageActive
    };
  }
});